import moment from 'moment';

import Model from 'src/storage/base';

export class DoctorModel extends Model {
  id = 'doctor';
  defaultState = () => ({
    doctor: null,
    slots: [],
    slotsMonth: [],
    selectedDate: moment()
  });
  apiConfig = {
    doctor_detail: {
      url: 'doctor/detail',
      validation: {
        username: 'string'
      },
      cancellable: true
    },
    list: {
      url: 'schedule/list',
      validation: {
        from: 'number',
        to: 'number'
      },
      cancellable: true
    }
  };

  loadDetail = (username, cb) => {
    this.setState({ doctor: {} });
    this.api('doctor_detail', { username }, (error, doctor, success) => {
      if (!error) {
        this.setState({
          doctor
        });
      }
      cb && cb(error, doctor, success);
    });
  };

  selectedDay = (day) => {
    this.setState({
      selectedDate: day,
      slots: this.state.slotsMonth.filter(
        (s) => s.startDate >= day.clone().startOf('day') && s.startDate <= day.clone().endOf('day')
      )
    });
  };

  selectedMonth = (day) => {
    const start = day.clone().startOf('month').startOf('week');
    const end = day.clone().endOf('month').endOf('week');
    this.setState({ slotsMonth: [] });
    this.api(
      'list',
      {
        id: this.state.doctor.id,
        from: Math.max(start.valueOf(), moment().valueOf()),
        to: end.valueOf()
      },
      (err, res, success) => {
        if (success)
          this.setState({
            slotsMonth: res.map((slot) => {
              slot.slotDate = moment(slot.startDate).format('YYYYMMDD');
              if (!slot.patientId) slot.patientId = 0;
              return slot;
            })
          });
        this.selectedDay(this.state.selectedDate);
      }
    );
  };
}

const model = new DoctorModel();
export default model;
